import { FacetAlias } from './facet';

export const FacetIcons = {
  [FacetAlias.house]: 'home',
  [FacetAlias.chapter]: 'chapter',
  [FacetAlias.car]: 'car',
  [FacetAlias.education]: 'education',
  [FacetAlias.bestFriend]: 'best_friend',
  [FacetAlias.employment]: 'employment',
  [FacetAlias.family]: 'family',
  [FacetAlias.music]: 'music',
  [FacetAlias.pet]: 'pet',
  [FacetAlias.sport]: 'sport',
  [FacetAlias.vacation]: 'vacation',
};

export const getFacetIcon = (facetAlias: FacetAlias): string => {
  return FacetIcons[facetAlias];
};
